module.exports = __webpack_public_path__ + "img/measurement_info_left_feet_front.3da21654.jpg";